module.exports = __webpack_public_path__ + "media/images/spree/frontend/content/giftcard/bg-d674c29f1700af40888b2a1b4d2d5f4a.jpg";